import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  MeetingProvider,
  MeetingConsumer,
  useMeeting,
  useParticipant,
} from "@videosdk.live/react-sdk";
import ReactPlayer from "react-player";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import JoinScreen from "./JoinScreen";
import MeetingView from "./MeetingView";
import { getProfileData } from "../../Redux/action/MasterAction";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import FeedbackForm from "../FeedbackForm/FeedbackForm";
import { getStudentOnlineLectureGroupMonthlyListData, getStudentOnlineLectureGroupTodayListData, getStudentOnlineLectureOneToOneMonthlyListData, getStudentOnlineLectureOneToOneTodayListData } from "../../Redux/action/StudentAction";
const MeetingFrame = () => {
  const { b64id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();



  const authToken = process.env.REACT_APP_VIDEO_SDK_TOKEN
  const Token = location?.state?.authToken
  const end_time = location?.state?.end_time
  const tutor_id = location?.state?.tutor_id
  const student_id = location?.state?.student_id
  const session_id = location?.state?.session_id
  console.log("session_id",session_id)
  const booked_id = location?.state?.booked_id
  const meeting_session_id = location?.state?.meeting_session_id

  const [endTime, setEndTime] = useState(end_time); 
  console.log("endTime",endTime)
   const {

        loadingStudentOnlineLectureOneToOneMonthlyApi,
        StudentOnlineLectureOneToOneMonthlyApiData,
        StudentOnlineLectureOneToOneMonthlyApiError,

        loadingStudentOnlineLectureOneToOneTodayApi,
        StudentOnlineLectureOneToOneTodayApiData,
        StudentOnlineLectureOneToOneTodayApiError,

        loadingStudentOnlineLectureGroupMonthlyApi,
        StudentOnlineLectureGroupMonthlyApiData,
        StudentOnlineLectureGroupMonthlyApiError,

        loadingStudentOnlineLectureGroupTodayApi,
        StudentOnlineLectureGroupTodayApiData,
        StudentOnlineLectureGroupTodayApiError
    } = useSelector(state => state?.StudentReducer);
  const [meetingId, setMeetingId] = useState(location?.state?.meetingLink)
  // const meetingId = location?.state?.meetingLink
  const getMinutesLeft = () => {
    const now = new Date();
    const end = new Date(endTime);
    return Math.floor((end - now) / 60000);
  };
  useEffect(() => {
    if (location?.state) {

      setMeetingId(location?.state?.meetingLink)
      // localStorage.setItem('meetinId', location?.state?.meetingLink)
    }
    else {

      navigate(-1)
    }
  }, [])


useEffect(() => {
  if (!endTime) return;

  const fetchData = () => {
    dispatch(getStudentOnlineLectureOneToOneTodayListData());
    dispatch(getStudentOnlineLectureGroupTodayListData());
    dispatch(getStudentOnlineLectureOneToOneMonthlyListData());
    dispatch(getStudentOnlineLectureGroupMonthlyListData());
  };

  const bufferMs = 20 * 60 * 1000; // 5 minutes before end
  const msUntilFetch = new Date(endTime).getTime() - Date.now() - bufferMs;

  let timeoutId;
  let intervalId;

  if (msUntilFetch <= 0) {
    // Already within 5 minutes → fetch immediately
    fetchData();
    intervalId = setInterval(fetchData, 30 * 1000); // every 30 sec
  } else {
    // Schedule first fetch 5 min before end
    timeoutId = setTimeout(() => {
      fetchData();
      intervalId = setInterval(fetchData, 30 * 1000); // start 30 sec polling
    }, msUntilFetch);
  }

  return () => {
    timeoutId && clearTimeout(timeoutId);
    intervalId && clearInterval(intervalId);
  };
}, [endTime]);
  // const meetingId = localStorage.getItem('meetinId')
useEffect(() => {
 const allCourses = [
    ...StudentOnlineLectureOneToOneTodayApiData,
    ...StudentOnlineLectureGroupTodayApiData,
    ...StudentOnlineLectureOneToOneMonthlyApiData,
    ...StudentOnlineLectureGroupMonthlyApiData
  ];
// console.log("isdmfsdh in use dffet")
  let updatedEndTime = null;

  // allCourses.forEach((course) => {
  //   // console.log("course?.course?.id",course?.course?.batches?.batchSession?.[0])
  //   if (course?.course?.id == session_id) {
  //     // course?.course?.batches?.batchSession?.forEach((session) => {
  //     //   if (session?.course_id == session_id) {
  //     //     updatedEndTime = session?.timeslots?.new_end_date_time;
  //     //     console.log("updatedEndTime",updatedEndTime)
  //     //   }
  //     // });
  //     updatedEndTime = course?.course?.batches?.batchSession?.[0]?.time_slot?.new_end_date_time
  //      console.log("updatedEndTime",updatedEndTime)
  //   }
  // });


allCourses.forEach((course) => {
  if (course?.course?.id == session_id) {

    // Group
    if (course?.course?.batches?.batchSession?.length > 0) {
      updatedEndTime =
        course?.course?.batches?.batchSession?.[0]?.time_slot?.new_end_date_time;
    }

    // One to one
    if (course?.course?.courseSession?.length > 0) {
      updatedEndTime =
        course?.course?.courseSession?.[0]?.timeslots?.new_end_date_time;
    }

    console.log("updatedEndTime", updatedEndTime);
  }
});

  if (updatedEndTime && updatedEndTime !== endTime) {
    setEndTime(updatedEndTime); // <-- UPDATE HERE
  }

}, [
  StudentOnlineLectureOneToOneTodayApiData,
  StudentOnlineLectureGroupTodayApiData,
  StudentOnlineLectureOneToOneMonthlyApiData,
  StudentOnlineLectureGroupMonthlyApiData
]);





  useEffect(() => {
    if (Token) {
      dispatch(getProfileData(Token))
    }
  }, [location, Token]);

  const {
    loadingProfileDataListApi,
    ProfileDataListApiData,
    ProfileDataListApiError,

  } = useSelector(state => state?.MasterReducer);

  const onMeetingLeave = () => {
    setMeetingId(null)

    if (ProfileDataListApiData?.data?.user_type == 'student') {
      navigate('/student/reviews', {
        state: {
          tutor_id: tutor_id,
          student_id: student_id,
          session_id: session_id,
          booked_id: booked_id
        }
      })
    }
    else {
      navigate(-1)
    }


  };

  useEffect(() => {
    if (!authToken || !meetingId) {
      navigate(-1); // Navigate to the previous page
    }
  }, [authToken, meetingId, navigate]);

  return authToken && meetingId ? (
    <>
      <MeetingProvider
        config={{
          meetingId,
          micEnabled: true,
          webcamEnabled: true,
          name: ProfileDataListApiData?.data?.name,
          metaData: {
            user_type: ProfileDataListApiData?.data?.user_type, 
            user_name: ProfileDataListApiData?.data?.name, 
          },
        }}
        token={authToken}
      >
        <MeetingView meetingId={meetingId} onMeetingLeave={onMeetingLeave} user_type={ProfileDataListApiData?.data?.user_type} user_name={ProfileDataListApiData?.data?.name} endTime={endTime} location={location?.state} />
      </MeetingProvider></>
  ) : (
    <div className="h-100 bg-dark"> <h1></h1></div>

  );
};

export default MeetingFrame;
